import {Component, OnInit} from '@angular/core';
import {ModalDismissReasons, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ConsultingService, LoaderService} from '@app/shared/services';
import {CommonModule, DatePipe, DecimalPipe} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {PageHeaderComponent} from '@app/components/page-header/page-header.component';
import {PaginationComponent} from '@app/components/pagination/pagination.component';

@Component({
  selector: 'app-purchase-return-list',
  templateUrl: './purchase-return-list.component.html',
  imports: [
    CommonModule,
    FormsModule,
    DecimalPipe,
    DatePipe,
    PageHeaderComponent,
    PaginationComponent
  ],
  styleUrls: ['./purchase-return-list.component.scss']
})
export class PurchaseReturnListComponent implements OnInit {
  public user_rights: any;
  public user_data: any = {};
  public now = new Date();
  public purchase_data: any = [];
  public purchase: any =
    {
      search_purchase: ''
    }
  start = 0;
  limit = 10;
  p = 50;
  public collection: any = '';
  page = 1;

  status: any;
  index: any;
  router: any;
  purchased: any;
  closeResult = '';
  public item_list: any = [];
  total = 0;
  price_total = 0;

  constructor(private loaderService: LoaderService, private modalService: NgbModal, public consultingService: ConsultingService) {

  }


  ngOnInit() {
    this.user_rights = JSON.parse(localStorage.getItem('user_rights') || "{}");
    this.user_data = JSON.parse(localStorage.getItem('user') || "{}");
    this.getPurchaseList();
  }

  public getPurchaseList(page = 0) {
    const limit = 50;
    this.start = page * limit;
    this.limit = limit;
    const postData = {
      start: this.start,
      limit: this.limit,
      purchase_id: '0'
    };
    this.loaderService.display(true);
    window.scrollTo(0, 0);
    this.loaderService.display(true);
    this.consultingService.listReturnPurchase(postData).subscribe((result: any) => {
      if (result['status'] == 'Success') {
        this.purchase_data = result['data'];
        this.collection = result['total_count'];
        this.loaderService.display(false);
      } else {
        this.loaderService.display(false);
        this.collection = 0;
      }
    });
  }

  public keyDownFunction(event: any) {
    if (event.keyCode == 13) {
      this.getsearchlist();
    }
  }

  getSum() {
    let total = 0;
    let price = 0;

    for (const item of this.item_list) {
      total = total + parseFloat(item.RETURN_AMOUNT);
      price = price + parseFloat(item.GROSS_AMOUNT);
    }
    this.total = total
    this.price_total = price

  }

  getsearchlist() {
    const limit = 50;
    this.start = 0;
    this.limit = limit;
    const postData = {
      start: this.start,
      limit: this.limit,
      search_text: this.purchase.search_purchase,
      purchase_id: '0'
    };
    this.collection = 0;
    this.purchase_data = [];
    this.loaderService.display(true);
    window.scrollTo(0, 0);
    this.consultingService.listReturnPurchase(postData).subscribe((result: any) => {
      if (result['status'] == 'Success') {
        this.purchase_data = result['data'];
        this.collection = result['total_count'];
        const i = this.purchase_data.length;
        this.index = i + 5;
        this.status = result['status'];
        this.loaderService.display(false);
      } 
      this.loaderService.display(false);
    });
  }

  public clear_search() {
    if (this.purchase.search_purchase != '') {
      this.purchase.search_purchase = '';
      this.getPurchaseList();
    }
  }

  public purached_items(item: any) {
    const postData = {
      purchase_return_id: item.PURCHASE_RETURN_ID
    };
    this.loaderService.display(true);
    window.scrollTo(0, 0);
    this.loaderService.display(true);
    this.consultingService.getReturnPurchase(postData).subscribe((result: any) => {
      if (result['status'] == 'Success') {
        this.purchased = result['data'];
        this.item_list = result['data'].PURCHASE_RETURN;
        this.getSum()
        this.loaderService.display(false);
      } else {
        this.loaderService.display(false);
      }
    });
  }

  protected open(content: any) {
    this.modalService.open(content, {
      ariaLabelledBy: 'modal-basic-title',
      size: 'lg',
      windowClass: "col-md-12"
    }).result.then((result: any) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason == ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason == ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
}
